import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
      realtime: {
        params: { eventsPerSecond: 10 },
      },
    })
  : null;

export function getStoragePublicUrl(storagePath) {
  if (!storagePath || !supabase) return null;
  if (storagePath.startsWith("http")) return storagePath;
  const { data } = supabase.storage.from("profile-images").getPublicUrl(storagePath);
  return data?.publicUrl ?? null;
}
